import { render, staticRenderFns } from "./FolderAndProjectBreadcrumb.vue?vue&type=template&id=5480aca6&scoped=true"
import script from "./FolderAndProjectBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FolderAndProjectBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./FolderAndProjectBreadcrumb.vue?vue&type=style&index=0&id=5480aca6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480aca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5480aca6')) {
      api.createRecord('5480aca6', component.options)
    } else {
      api.reload('5480aca6', component.options)
    }
    module.hot.accept("./FolderAndProjectBreadcrumb.vue?vue&type=template&id=5480aca6&scoped=true", function () {
      api.rerender('5480aca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/breadcrumb/FolderAndProjectBreadcrumb.vue"
export default component.exports